import { createSlice } from "@reduxjs/toolkit";

export const configurationSlice = createSlice({
  name: "configuration",
  initialState: {
    client: null,
    environment: null,
  },
  reducers: {
    setConfiguration: (state, action) => {
      if (action.payload.type === "client") {
        state.client = action.payload.value;
      } else {
        state.environment = action.payload.value;
      }
    },
    resetConfiguration: (state, action) => {
      state.client = null;
      state.environment = null;
    },
  },
});

export const { setConfiguration, resetConfiguration } =
  configurationSlice.actions;

export default configurationSlice.reducer;
